import { z } from 'zod/v4'

/**
 * Data object to store a user's info for marketing emails
 */
export const EmailCampaignNameValidator = z.enum(['coming-soon'])

export const BaseMarketingValidator = z.object({
	email: z.string(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	emailCampaignName: EmailCampaignNameValidator,
})

export const MarketingValidator = BaseMarketingValidator.extend({
	id: z.string(),
})

export type EmailCampaignName = z.infer<typeof EmailCampaignNameValidator>
export type BaseMarketing = z.infer<typeof BaseMarketingValidator>
export type Marketing = z.infer<typeof MarketingValidator>
